/*
 * Ryan O'Dowd
 * 2022-04-18
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import Button from '@components/common/Button';
import FormControl from '@components/common/FormControl';
import Text from '@components/common/Text';
import TextInput from '@components/common/TextInput';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';
import {
  sendContactFormMessage,
} from '@utils/store/actions';

const ContactForm = (props: ContactFormProps) => {
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);
  const dispatch = hooks.useTypedDispatch();

  const [_firstNameText, setFirstNameText] = useState('');
  const [_lastNameText, setLastNameText] = useState('');
  const [_emailText, setEmailText] = useState('');
  const [_howDidYouHearText, setHowDidYouHearText] = useState('');
  const [_messageText, setMessageText] = useState('');
  const [_formSubmitted, setFormSubmitted] = useState(false);

  return (
    <View style={styles.container}>
      <Text style={props.textStyles}>{props.leadingText}</Text>
      {_formSubmitted
        ? (
          <Text style={styles.thanksText}>Thanks for the message!</Text>
        ) : (
          <FormControl addPadding={true}>
            <View style={styles.fullWidth}>
              <FormControl.Row>
                <TextInput
                  label='First name'
                  mode='outlined'
                  value={_firstNameText}
                  onChangeText={(text) => setFirstNameText(text)}
                />
                <TextInput
                  label='Last name'
                  mode='outlined'
                  value={_lastNameText}
                  onChangeText={(text) => setLastNameText(text)}
                />
              </FormControl.Row>
              <FormControl.Row>
                <TextInput
                  label='Email address'
                  mode='outlined'
                  value={_emailText}
                  onChangeText={(text) => setEmailText(text)}
                />
              </FormControl.Row>
              <FormControl.Row>
                <TextInput
                  label='How did you hear about us?'
                  mode='outlined'
                  value={_howDidYouHearText}
                  onChangeText={(text) => setHowDidYouHearText(text)}
                />
              </FormControl.Row>
              <FormControl.Row>
                <TextInput
                  label='Message'
                  mode='outlined'
                  multiline={true}
                  numberOfLines={4}
                  value={_messageText}
                  onChangeText={(text) => setMessageText(text)}
                />
              </FormControl.Row>
              <Button
                style={styles.submitButton}
                disabled={!(_firstNameText && _lastNameText && _emailText)}
                onPress={() => {
                  // @TODO: form validation for required fields
                  dispatch(sendContactFormMessage(_firstNameText, _lastNameText, _emailText, _howDidYouHearText, _messageText));
                  setFormSubmitted(true);
                }}
              >
                {i18n('submit')}
              </Button>
            </View>
          </FormControl>
        )
      }
    </View>
  );
};

class ContactFormProps {
  leadingText: string | any;

  textStyles?: any;
};

export default ContactForm;
